/* eslint-disable implicit-arrow-linebreak, no-restricted-globals, camelcase */
// returns true if user is past the cutoff time
export const pastCutoff = (date) => {
  if (!date) {
    return false;
  }

  const now = new Date();
  const cutoffTime = new Date(date);

  if (isNaN(cutoffTime) || now > cutoffTime) {
    return true;
  }
  return false;
};

export const canCancel = (reservation) =>
// is it past cutoff or is it allowed?
  reservation?.change?.allowed === true
    && !pastCutoff(reservation?.change?.date_cut_off);
